import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { addAdmission, deleteAdmission } from "../../api/api";
import { useGlobalData } from "../../context/GlobalDataContext";
import "./AdminPanel.css";

const createInitialForm = () => ({
  title: "",
  slug: ""
});


function AdmissionAdminPanel() {
  const { threeTable, fetchThreeTable } = useGlobalData();
  const [admissions, setAdmissions] = useState([]);
  const [formData, setFormData] = useState(createInitialForm());
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('darkMode') === 'true');
  const role = localStorage.getItem("role");

    useEffect(() => {
    let mounted = true;

    const ensureAdmissions = async () => {
      try {
        if (!threeTable?.admissions?.length) {
          setIsLoading(true);
          await fetchThreeTable();
        }
      } catch (e) {
        if (mounted) setError(e.message || "Unable to load admissions");
      }
    };

    ensureAdmissions();
    return () => {
      mounted = false;
    };
  }, [threeTable?.admissions?.length, fetchThreeTable]);


  useEffect(() => {
    const syncDarkMode = () => setDarkMode(localStorage.getItem('darkMode') === 'true');
    window.addEventListener('storage', syncDarkMode);
    window.addEventListener('darkModeChanged', syncDarkMode);
    return () => {
      window.removeEventListener('storage', syncDarkMode);
      window.removeEventListener('darkModeChanged', syncDarkMode);
    };
  }, []);

  useEffect(() => {
    setAdmissions(threeTable.admissions || []);
    setIsLoading(false);
  }, [threeTable.admissions]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage("");
    setError("");

    try {
      const title = formData.title.trim();
      const slug = formData.slug.trim();

      if (!title) {
        throw new Error("Title required hai.");
      }

      if (!slug) {
        throw new Error("Slug required hai.");
      }

      await addAdmission({
        title,
        slug,
        jobSlug: slug,
        admissionLink: ""
      });

      setMessage("Admission detail save ho gaya.");
      setFormData(createInitialForm());
      await fetchThreeTable();
    } catch (submitError) {
      setError(submitError.response?.data?.error || submitError.message || "Unable to save admission detail");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Is admission detail ko delete karna hai?")) {
      return;
    }

    try {
      const deletingItem = admissions.find((item) => item._id === id);
      await deleteAdmission(id);

      if ((deletingItem?.jobSlug || deletingItem?.slug) === formData.slug) {
        setFormData(createInitialForm());
      }
      setMessage("Admission detail delete ho gaya.");
      await fetchThreeTable();
    } catch (deleteError) {
      setError(deleteError.response?.data?.error || deleteError.message || "Unable to delete admission detail");
    }
  };

  if (role !== "superadmin") {
    return (
      <div className="admin-panel-error">❌ Access denied! Only Superadmin can access this panel.</div>
    );
  }

  return (
    <div
      className={`resource-admin-panel resource-admin-panel--orange${darkMode ? ' dark-mode' : ''}`}
      style={{
        backgroundColor: darkMode ? '#232836' : '#fff7ed',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '30px',
        border: `2px solid ${darkMode ? '#f97316' : '#f97316'}`
      }}
    >
      <h2 style={{ color: darkMode ? '#fdba74' : '#9a3412', marginTop: 0 }}>🎓 Admission Admin Panel</h2>
      <p style={{ color: darkMode ? '#b0b8c9' : '#444', marginBottom: '16px' }}>Yahan admission detail manually title aur slug ke saath save, load list aur delete kar sakte ho.</p>

      <form
        onSubmit={handleSubmit}
        style={{
          backgroundColor: darkMode ? '#181c24' : 'white',
          padding: '15px',
          borderRadius: '5px',
          marginBottom: '20px'
        }}
      >
        <div style={{ display: 'grid', gap: '14px' }}>
          <label>
            <span>Admission Title</span>
            <input
              value={formData.title}
              onChange={(event) => setFormData((current) => ({ ...current, title: event.target.value }))}
              placeholder="UP Scholarship Admission 2026"
              style={{ background: darkMode ? '#232836' : undefined, color: darkMode ? '#fff' : undefined }}
            />
          </label>

          <label>
            <span>Slug</span>
            <input
              value={formData.slug}
              onChange={(event) => setFormData((current) => ({ ...current, slug: event.target.value }))}
              placeholder="up-scholarship-admission-2026"
              style={{ background: darkMode ? '#232836' : undefined, color: darkMode ? '#fff' : undefined }}
            />
          </label>
        </div>

        {message && <div style={{ marginTop: '16px', padding: '12px', borderRadius: '6px', backgroundColor: darkMode ? '#1a2e22' : '#ecfdf5', color: darkMode ? '#7ee787' : '#166534' }}>{message}</div>}
        {error && <div style={{ marginTop: '16px', padding: '12px', borderRadius: '6px', backgroundColor: darkMode ? '#2e1a1a' : '#fef2f2', color: darkMode ? '#ff7b72' : '#b91c1c' }}>{error}</div>}

        <button
          type="submit"
          style={{
            width: '100%',
            marginTop: '18px',
            padding: '12px',
            backgroundColor: darkMode ? '#f97316' : '#f97316',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          Save Admission Detail
        </button>
      </form>

      <h3 style={{ color: darkMode ? '#fdba74' : '#9a3412' }}>Saved Admission Details</h3>
      {isLoading && <p>Loading saved admissions...</p>}
      {!isLoading && admissions.length === 0 && <p style={{ color: darkMode ? '#b0b8c9' : '#666' }}>Abhi tak koi admission detail save nahi hui hai.</p>}
      {!isLoading && admissions.length > 0 && (
        <div
          style={{
            display: 'grid',
            gap: '12px',
            maxHeight: '320px',
            overflowY: 'auto',
            paddingRight: '8px'
          }}
        >
          {admissions.map((admission) => {
            const isPending = admission.status === "pending";
            const statusColor = isPending ? "#f7b500" : "#2ecc40";
            return (
              <div
                key={admission._id}
                style={{
                  backgroundColor: darkMode ? '#181c24' : 'white',
                  border: `1px solid ${darkMode ? '#fdba74' : '#fed7aa'}`,
                  borderRadius: '8px',
                  padding: '14px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '12px',
                  alignItems: 'center'
                }}
              >
                <div>
                  <strong style={{ color: darkMode ? '#fff' : undefined }}>{admission.title}</strong>
                  <div style={{ color: darkMode ? '#b0b8c9' : '#666', marginTop: '4px' }}>Slug: {admission.slug}</div>
                </div>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'flex-end', alignItems: 'center' }}>
                  <span style={{
                    background: statusColor,
                    color: '#fff',
                    borderRadius: 6,
                    padding: '2px 10px',
                    fontWeight: 600,
                    fontSize: 13,
                    marginRight: 8
                  }}>{admission.status === "pending" ? "Pending" : "Approved"}</span>
                  <Link
                    to={`/mform/${admission.jobSlug || admission.slug}`}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      padding: '8px 12px',
                      borderRadius: '4px',
                      backgroundColor: darkMode ? '#232836' : '#ffedd5',
                      color: darkMode ? '#fdba74' : '#9a3412',
                      textDecoration: 'none',
                      fontWeight: 'bold'
                    }}
                  >
                    View Page
                  </Link>
                  <button
                    className="admin-delete-button"
                    type="button"
                    onClick={() => handleDelete(admission._id)}
                    style={{
                      padding: '8px 12px',
                      borderRadius: '4px',
                      backgroundColor: '#d32f2f',
                      color: 'white',
                      border: 'none',
                      fontWeight: 'bold',
                      cursor: 'pointer'
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default AdmissionAdminPanel;
